module.exports = __webpack_public_path__ + "img/niger.3f0352e6.svg";